import type { AppointmentBookingSettings } from '../types';

interface isCalendarIntegrationEnabledProps {
  integrationGoogleCalendarAuth: AppointmentBookingSettings['integrationGoogleCalendarAuth'];
  integrationGoogleCalendarCalendar: AppointmentBookingSettings['integrationGoogleCalendarCalendar'];
}

export function isCalendarIntegrationEnabled({
  integrationGoogleCalendarAuth,
  integrationGoogleCalendarCalendar
}: isCalendarIntegrationEnabledProps) {
  const isAuthenticated =
    integrationGoogleCalendarAuth?.status === 'connected' &&
    !!integrationGoogleCalendarAuth?.identity;

  const isCalendarSelected = !!integrationGoogleCalendarCalendar?.id;

  return isAuthenticated && isCalendarSelected;
}
